import React from 'react';
import { withRouter } from 'react-router-dom';

import ContentLayout from 'component/page/content';
import PricingSection from 'component/content/pricing';

import API, {handleError} from 'utils/xhr';


class Page extends React.Component {

  state = {
    tier_data: null,
    loader: {
      fetching_tier: false,
    }
  }

  componentDidMount(){
    const state = this.state;
    state.loader.fetching_tier = true;
    this.setState(state);

    const url = '/payments/tiers/me';
    API.get(url).then(response =>{
      const state = this.state;
      state.tier_data = response.data.data;
      state.loader.fetching_tier = false;

      // if (state.user_data.user){
      //   state.user_post = {
      //     name: state.user_data.user.nickname,
      //     email: state.user_data.user.email,
      //   }
      // }
      this.setState(state);
    },(error) =>{
      const state = this.state;
      state.loader.fetching_tier = false;
      this.setState(state);
    handleError(error, this.props.history);
    })
  }

  render (){

    const tier = (this.state.tier_data)? (this.state.tier_data.tier) : null;
    return (
      <ContentLayout id="billing-page">
        <PricingSection tier={tier} fetching_data={this.state.loader.fetching_tier} />
      </ContentLayout>
    )
  }
}

export default withRouter(Page);